import { render, staticRenderFns } from "./DashboardGoldenmetrics.vue?vue&type=template&id=4eaa40e9"
import script from "./DashboardGoldenmetrics.vue?vue&type=script&lang=js"
export * from "./DashboardGoldenmetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports